import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {MapSectionKey} from "../utils/branchDiff";

// Removes one entry from a key→value map section, propagating a deletion that
// Other already made (the entry exists only on Current). `path` matches
// SetMapEntryCommand: [key] for single-level maps, [lang, key] for localization.
export class RemoveMapEntryCommand extends CommandBase {
    sectionKey: MapSectionKey;
    path: string[];

    constructor(sectionKey: MapSectionKey, path: string[]) {
        super();
        this.sectionKey = sectionKey;
        this.path = path;
    }

    execute(data: RemoteConstantsModel): boolean {
        if (this.path.length === 0) return false;
        const root = sectionRoot(data, this.sectionKey);
        if (!root) return false;

        let parent: Record<string, unknown> = root;
        for (const seg of this.path.slice(0, -1)) {
            const next = parent[seg];
            if (typeof next !== 'object' || next === null) return false;
            parent = next as Record<string, unknown>;
        }
        const leaf = this.path[this.path.length - 1];
        if (!(leaf in parent)) return false;
        delete parent[leaf];
        return true;
    }
}

function sectionRoot(data: RemoteConstantsModel, sectionKey: MapSectionKey): Record<string, unknown> | undefined {
    switch (sectionKey) {
        case 'localization': return data.localization as Record<string, unknown> | undefined;
        case 'sounds':       return data.sounds as Record<string, unknown> | undefined;
        case 'images':       return data.images as Record<string, unknown> | undefined;
        case 'imagePacks':   return data.imagePacks as Record<string, unknown> | undefined;
        case 'constructionImagePacks': return data.constructionImagePacks as Record<string, unknown> | undefined;
    }
}
